import request from "./request";
import apis from "./apis";

const {
  signInfo,
  signIn,
  cancelSignIn,
} = apis.attendance;

const attendance = {
  getSignInfo: (data: Object) => {
    return request.get(signInfo, data);
  },
  signIn: (data: Object) => {
    return request.post(signIn, data);
  },
  cancelSignIn: (data: Object) => {
    return request.post(cancelSignIn, data);
  },
};

export default attendance;